export const SMS = [
  {
    title: "Registration",
    isSystemMessage: true,
    status: "active",
    date: "20-10-2020",
  },
  {
    title: "Patient Appointment Remin...",
    isSystemMessage: true,
    status: "inactive",
    date: "20-10-2020",
  },
  {
    title: "Invoice",
    isSystemMessage: true,
    status: "active",
    date: "20-10-2020",
  },
  {
    title: "Referral",
    isSystemMessage: true,
    status: "inactive",
    date: "20-10-2020",
  },
  {
    title: "Investigate",
    isSystemMessage: true,
    status: "active",
    date: "20-10-2020",
  },
  {
    title: "Procedure",
    isSystemMessage: false,
    status: "active",
    date: "20-10-2020",
  },
  {
    title: "Birthday Message",
    isSystemMessage: false,
    status: "active",
    date: "20-10-2020",
  },
  {
    title: "Appreciation Message",
    isSystemMessage: false,
    status: "active",
    date: "20-10-2020",
  },
  {
    title: "Wallet Deduction",
    isSystemMessage: false,
    status: "inactive",
    date: "20-10-2020",
  },
  {
    title: "End Consultation",
    isSystemMessage: false,
    status: "active",
    date: "20-10-2020",
  },
  {
    title: "Christmas Message",
    isSystemMessage: false,
    status: "active",
    date: "20-10-2020",
  },
];

export const SMS_LOGS = [
  {
    recipient: {
      name: "Layor Pan",
      phoneNumber: "+234708108023",
    },
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    status: "sent",
    createdAt: "2024-09-05T10:11:19.985+00:00",
    amount: 4000,
  },
  {
    title: "Patient Appointment Remin...",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    status: "sent",
    createdAt: "2024-09-05T10:11:19.985+00:00",
    recipient: {
      name: "Layor Pan",
      phoneNumber: "+234708108023",
    },
    amount: 40000,
  },
  {
    title: "Invoice",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: true,
    status: "delivered",
    createdAt: "2021-06-01T00:00:00.000+00:00",
    recipient: {
      name: "Albert Flores",
      phoneNumber: "09058903456",
    },
    amount: 400,
  },
  {
    title: "Referral",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: true,
    status: "failed",
    createdAt: "2021-06-11T10:52:21.719+00:00",
    recipient: {
      name: "Guy Hawkins",
      phoneNumber: "(09036759987)",
    },
    amount: 4000,
  },
  {
    title: "Investigate",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: true,
    status: "failed",
    createdAt: "2021-06-01T00:00:00.000+00:00",
    recipient: {
      name: "Kristin Watson",
      phoneNumber: "09124568976",
    },
    amount: 4000,
  },
  {
    title: "Procedure",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: false,
    status: "sent",
    createdAt: "2021-06-11T10:52:21.719+00:00",
    recipient: {
      name: "Kristin Watson",
      phoneNumber: "09124568976",
    },
    amount: 4000,
  },
  {
    title: "Birthday Message",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: false,
    status: "delivered",
    createdAt: "2023-10-26T08:52:11.416+00:00",
    recipient: {
      name: "Kristin Watson",
      phoneNumber: "09124568976",
    },
    amount: 4000,
  },
  {
    title: "Appreciation Message",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: false,
    status: "sent",
    createdAt: "2021-11-11T00:00:00.000+00:00",
    recipient: {
      name: "Kristin Watson",
      phoneNumber: "09124568976",
    },
    amount: 4000,
  },
  {
    title: "Wallet Deduction",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: false,
    status: "delivered",
    createdAt: "2022-04-14T00:00:00.000+00:00",
    recipient: {
      name: "Kristin Watson",
      phoneNumber: "09124568976",
    },
    amount: 4000,
  },
  {
    title: "End Consultation",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: false,
    status: "delivered",
    createdAt: "2022-04-14T00:00:00.000+00:00",
    recipient: {
      name: "Kristin Watson",
      phoneNumber: "09124568976",
    },
    amount: 4000,
  },
  {
    title: "Christmas Message",
    body: "Dear Firstname, We would like to wish you happy birthday and many happy returns from all of us at Layor Hospital",
    isSystemMessage: false,
    status: "delivered",
    createdAt: "2022-03-27T14:30:36.790+00:00",
    recipient: {
      name: "Kristin Watson",
      phoneNumber: "09124568976",
    },
    amount: 4000,
  },
];

export const SMS_VARIABLES = [
  "{first_name}",
  "{last_name}",
  "{medical_record_number}",
  "{phone_number}",
  "{feedback_link}",
  "{hospital_name}",
  "{doctor_name}",
  "{contact_info}",
  "{appointment_date}",
  "{appointment_time}",
  "{hospital_location}",
  "{credit_amount}",
];

export const TASK_STATUS_VARIABLES = [...SMS_VARIABLES, "{hospital_name}", "{full_name}", "{status}", "{test_name}"];

export const PURPOSE_OPTIONS = [
  { label: "Birthday", value: "birthday" },
  { label: "Registration", value: "registration" },
  { label: "Appointment visit", value: "appointment visit" },
  { label: "Appointment completion", value: "appointment completion" },
  { label: "Recommended Surgery", value: "recommended surgery" },
  { label: "Confirm Surgery", value: "confirm surgery" },
  { label: "Recommended Procedure", value: "recommended procedure" },
  { label: "Recommend Admission", value: "recommended admission" },
  { label: "Discharge", value: "discharge" },
  { label: "Prescription", value: "prescription" },
  { label: "Payment completion", value: "payment" },
  { label: "Debt Reminder", value: "debt reminder" },
  { label: "Patient Credit", value: "patient credit" },
  { label: "Lab Result", value: "lab result" },
  { label: "Follow Up Visit", value: "follow up visit" },
];

export const SMS_FREQUENCY = {
  "appointment visit": [
    {
      label: "2hrs before Appointment date",
      value: "2hrs before Appointment date",
      interval: "minutes",
      frequency: "2",
      beforeOrAfter: "before",
    },
    {
      label: "6hrs before Appointment date",
      value: "6hrs before Appointment date",
      interval: "minutes",
      frequency: "6",
      beforeOrAfter: "before",
    },
    {
      label: "24hrs before Appointment date",
      value: "24hrs before Appointment date",
      interval: "minutes",
      frequency: "24",
      beforeOrAfter: "before",
    },
    {
      label: "48hrs before Appointment date",
      value: "48hrs before Appointment date",
      interval: "minutes",
      frequency: "48",
      beforeOrAfter: "before",
    },
  ],
  "recommended surgery": [
    {
      label: "2hrs before surgery date",
      value: "2hrs before surgery date",
      interval: "minutes",
      frequency: "2",
      beforeOrAfter: "before",
    },
    {
      label: "6hrs before surgery date",
      value: "6hrs before surgery date",
      interval: "minutes",
      frequency: "6",
      beforeOrAfter: "before",
    },
    {
      label: "24hrs before surgery date",
      value: "24hrs before surgery date",
      interval: "minutes",
      frequency: "24",
      beforeOrAfter: "before",
    },
    {
      label: "48hrs before surgery date",
      value: "48hrs before surgery date",
      interval: "minutes",
      frequency: "48",
      beforeOrAfter: "before",
    },
  ],
  "confirm surgery": [
    {
      label: "24hrs before surgery date",
      value: "24hrs before surgery date",
      interval: "minutes",
      frequency: "24",
      beforeOrAfter: "before",
    },
    {
      label: "48hrs before surgery date",
      value: "48hrs before surgery date",
      interval: "minutes",
      frequency: "48",
      beforeOrAfter: "before",
    },
    {
      label: "72hrs before surgery date",
      value: "72hrs before surgery date",
      interval: "minutes",
      frequency: "72",
      beforeOrAfter: "before",
    },
  ],
  "recommended procedure": [
    {
      label: "2hrs before procedure date",
      value: "2hrs before procedure date",
      interval: "minutes",
      frequency: "2",
      beforeOrAfter: "before",
    },
    {
      label: "6hrs before procedure date",
      value: "6hrs before procedure date",
      interval: "minutes",
      frequency: "6",
      beforeOrAfter: "before",
    },
    {
      label: "24hrs before procedure date",
      value: "24hrs before procedure date",
      interval: "minutes",
      frequency: "24",
      beforeOrAfter: "before",
    },
    {
      label: "48hrs before procedure date",
      value: "48hrs before procedure date",
      interval: "minutes",
      frequency: "48",
      beforeOrAfter: "before",
    },
  ],
  "recommended admission": [
    {
      label: "2hrs before checkin date",
      value: "2hrs before checkin date",
      interval: "minutes",
      frequency: "2",
      beforeOrAfter: "before",
    },
    {
      label: "6hrs before checkin date",
      value: "6hrs before checkin date",
      interval: "minutes",
      frequency: "6",
      beforeOrAfter: "before",
    },
    {
      label: "24hrs before checkin date",
      value: "24hrs before checkin date",
      interval: "minutes",
      frequency: "24",
      beforeOrAfter: "before",
    },
    {
      label: "48hrs before checkin date",
      value: "48hrs before checkin date",
      interval: "minutes",
      frequency: "48",
      beforeOrAfter: "before",
    },
  ],
  recall: [
    {
      label: "Weekly after recall is initiated",
      value: "Weekly after recall is initiated",
      interval: "minutes",
      frequency: "1",
      beforeOrAfter: "after",
    },
    {
      label: "Bi-Weekly after recall is initiated",
      value: "Bi-Weekly after recall is initiated",
      interval: "minutes",
      frequency: "2",
      beforeOrAfter: "after",
    },
    {
      label: "Monthly after recall is initiated",
      value: "Monthly after recall is initiated",
      interval: "minutes",
      frequency: "1",
      beforeOrAfter: "after",
    },
  ],
  "debt reminder": [
    {
      label: "Weekly after credit is applied",
      value: "Weekly after credit is applied",
      interval: "minutes",
      frequency: "1",
      beforeOrAfter: "after",
    },
  ],
};

export const SMS_RECIPIENT_TYPE = {
  PATIENT: "Patient",
  STAFF: "Staff",
  BOTH: "Both",
};

// export const SMS_FREQUECY = {
//     "Appointment visit": [
//         { label: "2hrs before Appointment date", value: "2hrs before Appointment date", interval: "hours", frequency: "2", beforeOrAfter: "before" },
//         { label: "6hrs before Appointment date", value: "6hrs before Appointment date", interval: "hours", frequency: "6", beforeOrAfter: "before" },
//         { label: "24hrs before Appointment date", value: "24hrs before Appointment date",interval: "hours", frequency: "24", beforeOrAfter: "before"},
//         { label: "48hrs before Appointment date", value: "48hrs before Appointment date",interval: "hours", frequency: "48", beforeOrAfter: "before"},
//     ],
//     "Recommended Surgery": [
//         { label: "2hrs before surgery date", value: "2hrs before surgery date", interval: "hours", frequency: "2", beforeOrAfter: "before" },
//         { label: "6hrs before surgery date", value: "6hrs before surgery date", interval: "hours", frequency: "6" , beforeOrAfter: "before"},
//         { label: "24hrs before surgery date", value: "24hrs before surgery date", interval: "hours", frequency: "24", beforeOrAfter: "before" },
//         { label: "48hrs before surgery date", value: "48hrs before surgery date", interval: "hours", frequency: "48", beforeOrAfter: "before" },
//     ],
//     "Confirm Surgery": [
//         { label: "24hrs before surgery date", value: "24hrs before surgery date", interval: "hours", frequency: "24", beforeOrAfter: "before" },
//         { label: "48hrs before surgery date", value: "48hrs before surgery date", interval: "hours", frequency: "48", beforeOrAfter: "before" },
//         { label: "72hrs before surgery date", value: "72hrs before surgery date", interval: "hours", frequency: "72", beforeOrAfter: "before" },
//     ],
//     "Recommended Procedure": [
//         { label: "2hrs before procedure date", value: "2hrs before procedure date", interval: "hours", frequency: "2", beforeOrAfter: "before" },
//         { label: "6hrs before procedure date", value: "6hrs before procedure date", interval: "hours", frequency: "6", beforeOrAfter: "before" },
//         { label: "24hrs before procedure date", value: "24hrs before procedure date", interval: "hours", frequency: "24", beforeOrAfter: "before" },
//         { label: "48hrs before procedure date", value: "48hrs before procedure date", interval: "hours", frequency: "48", beforeOrAfter: "before" },
//     ],
//     "Recommended Admission": [
//         { label: "2hrs before checkin date", value: "2hrs before checkin date", interval: "hours", frequency: "2", beforeOrAfter: "before" },
//         { label: "6hrs before checkin date", value: "6hrs before checkin date", interval: "hours", frequency: "6", beforeOrAfter: "before" },
//         { label: "24hrs before checkin date", value: "24hrs before checkin date", interval: "hours", frequency: "24", beforeOrAfter: "before" },
//         { label: "48hrs before checkin date", value: "48hrs before checkin date", interval: "hours", frequency: "48", beforeOrAfter: "before" },
//     ],
//     "Recall": [
//         {
//             label:"Weekly after recall is initiated",
//             value: "Weekly after recall is initiated",
//             interval: "weekly", frequency: "1", beforeOrAfter: "after"
//         },
//         {
//             label:"Bi-Weekly after recall is initiated",
//             value:"Bi-Weekly after recall is initiated",
//             interval:"weekly",frequency:"bi",beforeOrAfter:"after"
//         },
//         {
//             label:"Monthly after recall is initiated",
//             value: "Monthly after recall is initiated",
//             interval: "monthly", frequency: "1", beforeOrAfter: "after"
//         },
//     ],
//     "Debt Reminder": [
//         {
//             label:"Weekly after credit is applied",
//             value: "Weekly after credit is applied",
//             interval: "weekly", frequency: "1", beforeOrAfter: "after"
//         }
//     ],
// }
